import { type ColumnOption } from "interfaces/columnOptions";
import dateTimeUtils from "utils/dateTimeUtils";
import { type CampaignSendOverview } from "../../types/state";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./statuses.module.scss";
import { CampaignRunStatusToColor, CampaignRunStatusToIcon } from "./constants";
import { CampaignRunItemMenu } from "./CampaignRunItemMenu";

export enum Columns {
  ScheduledTime = "Scheduled Time",
  Status = "Status",
}

export const ColumnToParamMap: {
  [P in Lowercase<Columns>]: string;
} = {
  "scheduled time": "startDateTime",
  status: "campaignRunStatusId",
};

interface GetColumnOptionsParams {
  readonly?: boolean;
  handleCompleteClick: (id: number) => void;
  handleCancelClick: (id: number) => void;
}

export const getColumnOptions = (params: GetColumnOptionsParams): ColumnOption<CampaignSendOverview>[] => {
  return [
    {
      name: Columns.ScheduledTime,
      width: 5,
      isSortable: true,
      render: (item: CampaignSendOverview) => dateTimeUtils.localFormatWithValidation(item.startDate),
    },
    {
      name: Columns.Status,
      width: 3,
      isSortable: true,
      render: (item: CampaignSendOverview) => (
        <div>
          <FontAwesomeIcon
            icon={CampaignRunStatusToIcon[item.statusId]}
            className={`${styles[CampaignRunStatusToColor[item.statusId]]}`}
          />
          &nbsp;
          {item.statusName}
        </div>
      ),
    },
    {
      name: "",
      width: 1,
      className: "align-right",
      isSortable: false,
      render: (item: CampaignSendOverview, isChecked?: boolean) => {
        return (
          <CampaignRunItemMenu
            item={item}
            isChecked={isChecked}
            readonly={params.readonly}
            hasPermission={!params.readonly}
            handleCompleteClick={params.handleCompleteClick}
            handleCancelClick={params.handleCancelClick}
          />
        );
      },
    },
  ];
};
